/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_MonthlyInputs */

const en_gc_home_monthly = /** @type {(inputs: Gc_Home_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A small monthly budget`)
};

const zh_gc_home_monthly = /** @type {(inputs: Gc_Home_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一份简单月度预算`)
};

/**
* | output |
* | --- |
* | "A small monthly budget" |
*
* @param {Gc_Home_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_monthly = /** @type {((inputs?: Gc_Home_MonthlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_MonthlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_monthly(inputs)
	return zh_gc_home_monthly(inputs)
});
export { gc_home_monthly as "gc.home.monthly" }